// extracted by mini-css-extract-plugin
module.exports = {"quillWrapper":"styles_quillWrapper__2pGqD"};